import { render, staticRenderFns } from "./GraphSetting.vue?vue&type=template&id=572d0d9a&scoped=true"
import script from "./GraphSetting.vue?vue&type=script&lang=ts"
export * from "./GraphSetting.vue?vue&type=script&lang=ts"
import style0 from "./GraphSetting.vue?vue&type=style&index=0&id=572d0d9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572d0d9a",
  null
  
)

export default component.exports